import { render } from "./AntiRaggingView.vue?vue&type=template&id=054309c2"
import script from "./AntiRaggingView.vue?vue&type=script&lang=js"
export * from "./AntiRaggingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__